import { API, graphqlOperation } from 'aws-amplify';
//import { createCompany, updateCompany, deleteCompany } from './graphql/mutations';
//import { listCompanys } from './graphql/queries';

const getRecommendationsArray = function(rec) {
  if(!rec) {
    return [];
  }
  var products = [];
  for(var i = 0; i < rec.score; i++) {
    /* cant be used until Amplify allows nullable connections */
    if(rec[`product${i}`] && rec[`product${i}`].url) {
      var p = rec[`product${i}`];
      p.personalized = true;
      p.scoreIncrement = rec.score - i;
      products.push(p);
    }
    
  }
  return products;
}

export default {
    namespaced:true,
    state: {
        list: null,
        item: null,
        nextToken: null,
    },
    mutations: {
        list: (state, payload) => { state.list = payload.append ? (state.list || []).concat(payload.value) : payload.value },
        item: (state, payload) => { state.item = payload.value },
        nextToken: (state, payload) => { state.nextToken = payload.value }
    },
    getters: {
       
    },
    actions: {
        async get(context, payload) {
            const v = await API.graphql(graphqlOperation(`query GetVisitor($id: ID!) {
              getVisitor(id: $id) {
                id
                activity
                lastAction
                recommendations(sortDirection: DESC) {
                  items {
                    id
                    score
                    product0 {
                      ...product
                    }
                    product1 {
                      ...product
                    }
                    product2 {
                      ...product
                    }
                    product3 {
                      ...product
                    }
                    product4 {
                      ...product
                    }
                    product5 {
                      ...product
                    }
                    product6 {
                      ...product
                    }
                    product7 {
                      ...product
                    }
                    product8 {
                      ...product
                    }
                    product9 {
                      ...product
                    }
                  }
                  nextToken
                }
                events(sortDirection:DESC) {
                  items {
                    id
                    productID
                    product {
                      ...product
                    }
                    scoreIncrement
                  }
                  nextToken
                }
              }
            }

            fragment product on Product {
              id
              url
              name
            }
            `, { id: payload.id }));
            var vr = v.data.getVisitor;
            vr.parsedRecommendations = getRecommendationsArray(vr.recommendations.items[0]);       
            context.commit('item', {value: v.data.getVisitor });

        },
        
        async list(context, payload) {
          //console.dir(payload);
          const c = await API.graphql(graphqlOperation(`
          query VisitorsByDomainActivity(
            $domainID: ID
            $activity: ModelIntKeyConditionInput
            $sortDirection: ModelSortDirection
            $filter: ModelVisitorFilterInput
            $limit: Int
            $nextToken: String
          ) {
            visitorsByDomainActivity(
              domainID: $domainID
              activity: $activity
              sortDirection: $sortDirection
              filter: $filter
              limit: $limit
              nextToken: $nextToken
            ) {
              items {
                id
                email
                lastAction
                registered
                activity
              }
              nextToken
            }
          }
          `, payload ));
          context.commit('list', {value: c.data.visitorsByDomainActivity.items, append: true });
          context.commit('nextToken', {value: c.data.visitorsByDomainActivity.nextToken });
        },

    }
}